module.exports = __webpack_public_path__ + "img/04.fdd94d1d.jpg";